import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { EntityProperty } from "@ryde/shared";

import { translateEntityPropertyKey } from "./use-entity-property-key-normalized.utils";

export const useEntityPropertyKeyNormalized = ({
  entity,
  entityProperty,
}: {
  entity: string | undefined;
  entityProperty: EntityProperty;
}): string => {
  const { t, i18n } = useTranslation();

  return useMemo(
    () =>
      translateEntityPropertyKey({ entity, key: entityProperty.key, t, i18n }),
    [entity, entityProperty.key, i18n, t],
  );
};
